import React, { useEffect, useState } from "react";
import InboxTable from './InboxTable'
import { Loader, Toast } from "@egovernments/digit-ui-react-components";
import FilterForm from "./FilterForm";
import { useTranslation } from "react-i18next";
import { TLService } from "../../../../../../../libraries/src/services/elements/TL";

function ApplicationDetail({ setApiData, apiData }) {
    const userInfo = Digit.UserService.getUser();
    let tenantId = Digit.ULBService.getCurrentTenantId();
    let userType = userInfo?.info?.roles?.some((role => role.code === "HRMS_ADMIN")) ? "Admin" : null
    const { t } = useTranslation();
    if (userType) {
        tenantId = Digit.ULBService.getStateId()
    }
    const [isLoading, setIsLoading] = useState(true);
    const [showToast, setShowToast] = useState(null);

    const fetchData = async (tenantId, params) => {
        setIsLoading(true);
        setShowToast(null);
        try {
            const result = await TLService.misReportRegistration(tenantId, params);
            console.log(result, "resultherere");
            if (!result) {
                throw new Error("No data received from server");
            } else if (result?.Licenses?.length === 0) {
                setShowToast({
                    key: "true",
                    warning: true,
                    message: "No Records Found",
                });
            }
            setApiData(result);
        } catch (err) {
            console.error("Error fetching data:", err);
            // handle API error message if available
            const message =
                err?.response?.data?.message ||
                err?.message ||
                "Something went wrong while fetching data";
            setShowToast({
                key: "true",
                error: true,
                message: message,
            });
            setApiData(null);
        } finally {
            setIsLoading(false);
        }
    };
    const closeToast = () => {
        setShowToast(null);
    };

    const handleFormSubmit = async (formData) => {
        let { formType, mobileNumber, applicationNumber, licenseNumbers } = formData;
        try {
            await fetchData(tenantId, { formType, mobileNumber, applicationNumber, licenseNumbers });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        const fetchDataOnMount = async () => {
            await fetchData(tenantId, { userType });
        };
        fetchDataOnMount();
    }, [tenantId]);

    return (
        <div>
            <FilterForm onSubmit={handleFormSubmit} />
            {isLoading && (
                <div>
                    <Loader />
                </div>
            )}
            {!isLoading && showToast && (
                <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
            )}

            {!isLoading && !showToast && apiData && (
                <InboxTable apiData={apiData} />
            )}
        </div>
    );

}

export default ApplicationDetail;
